import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-bar-title',
  templateUrl: './bar-title.component.html',
  styleUrls: ['./bar-title.component.css']
})
export class BarTitleComponent implements OnInit {

  constructor() {
  }

  ngOnInit(): void {
  }

}
